'use client';

import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { MiniMap } from '@/src/components/features/property/ui/MiniMap';
import { useIsDesktop } from '@/src/lib/hooks/ui/useIsDesktop';
import * as styles from './neighborhoodMapTrigger.styles';

type NeighborhoodMapTriggerProps = {
  listing: PropertyDetailListing;
};

const hasValidCoordinate = (lat: number | undefined, lon: number | undefined): lat is number =>
  lat != null && lon != null && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180 && (lat !== 0 || lon !== 0);

export function NeighborhoodMapTrigger({ listing }: NeighborhoodMapTriggerProps) {
  const t = useTranslations('hdp');
  const isDesktop = useIsDesktop();
  const lat = listing.geo?.lat;
  const lon = listing.geo?.lon;

  if (isDesktop || !hasValidCoordinate(lat, lon)) return null;

  const handleClick = () => {
    document.getElementById('neighborhood-module')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <button type="button" className={styles.trigger} onClick={handleClick} aria-label={t('viewNeighborhoodMap')}>
      <MiniMap lat={lat} lon={lon} size={52} />
    </button>
  );
}
